import React from 'react';
import { makeStyles } from '@material-ui/core';
import { tooltipStyle } from './utils';

const useStyles = makeStyles({
  container: {
    backgroundColor: '#fff',
    ...tooltipStyle
  }
});

export const TooltipBase = ({ children, style }: any) => {
  const classes = useStyles();
  return (
    <div className={classes.container} style={style}>
      {children}
    </div>
  );
};
